import {
  Component,
  OnInit,
  Inject,
  OnDestroy,
  HostListener
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  MsalService,
  MsalBroadcastService,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
} from '@azure/msal-angular';
import { EventMessage, EventType, InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import { TranslocoService } from '@ngneat/transloco';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, Subscription } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { ModalPopupComponent } from './layout/modal-popup/modal-popup.component';
import { DataStateKeeperService } from './services/data-state-keeper.service';
import { LogoutService } from './services/logout.service';
import { LoggedOutDialogComponent } from './shared/logged-out-dialog/logged-out-dialog.component';
import { LogoutUnsavedDataPopupComponent } from './shared/logout-unsaved-data-popup/logout-unsaved-data-popup.component';
import { ConnectivityStatusService } from './device-management/device-details/connectivity-status.service';
import { LoginSession, SingleSessionService } from './services/single-session.service';
import { SessionLoggedOutDialogComponent } from './shared/session-logged-out-dialog/session-logged-out-dialog.component';
import { BlobServiceClientService } from './services/blob-service-client.service';
import { NetworkListnerService } from './services/network-listner.service';
import { DashboardService } from './patch-management/dashboard/dashboard.service';
import { PatchUploadStatus } from './models/common/patchUploadStatus';
import { PatchManagementService } from './services/patch-management.service';
import { SendPackageSuccessDialogComponent } from './patch-management/send-package-dialog/send-package-success-dialog/send-package-success-dialog.component';
import { SendPackageErrorDialogComponent } from './patch-management/send-package-dialog/send-package-error-dialog/send-package-error-dialog.component';
import { ActivatedRoute } from '@angular/router';
import { ExternalAssetService } from './services/external-asset.service';
import * as moment from 'moment';
import { MessageBroadcastService } from './services/message-broadcast.service';
import { AuthService } from './utilities/auth/auth.service';
import { BroadcastMessageEvent } from './core/constants/BroadcastMessageEvent';
import { EventCode } from './core/constants/EventCode';
@Component({
  providers: [ModalPopupComponent],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  @HostListener('window:unload') unload() {
    this.blobServiceClientService.handlePatchUploadOnBrowserClose();
    this.messageBroadcastService.broadCast({event:BroadcastMessageEvent.patchProgressUpdateWithDelay});
  }

  title: any = 'RssUiApp';
  isIframe = false;
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();
  time: any;
  isTimeout: boolean = false;
  autoLoggoutTime: any;
  dataLostMessageTimer: any;
  //userInactivityTimeOut out in millisecond - 15 mins
  userInactivityTimeOut = 13 * 60 * 1000;
  autoLoggoutTimeOut = 2 * 60 * 1000;
  countDown = this.autoLoggoutTimeOut;
  msalSubscription!: Subscription;
  loginActivitySubscription!: Subscription;
  isInactivityCounterEnabled = true;
  extendedSessionCount = 0;
  private routeParams: any = '';
  private isLoggedOut = false
  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private spinner: NgxSpinnerService,
    private logoutService: LogoutService,
    private dataStateKeeperService: DataStateKeeperService,
    public dialog: MatDialog,
    public signalRService: ConnectivityStatusService,
    public singleSessionService: SingleSessionService,
    private translocoService: TranslocoService,
    private blobServiceClientService: BlobServiceClientService,
    private networkListnerService: NetworkListnerService,
    private dashboardService: DashboardService,
    private patchManagementService: PatchManagementService,
    private route: ActivatedRoute,
    private externalAssetService: ExternalAssetService,
    private messageBroadcastService:MessageBroadcastService,
    private authenticationHandlerService:AuthService
  ) {
    this.authenticationHandlerService.setUserData();
    this.signalRService.startConnection();
    this.signalRService.userSignInListner();
    this.signalRService.deploymentResponseListener();
    this.messageBroadcastService.listen();
  }

  ngOnInit(): void {
    this.signalRService.connectivityStatusListener();
    if (this.routeParams == '') {
      this.routeParams = location.href;
    }    
    this.route.queryParams.subscribe(params => {
     console.log(params);     
  });
  this.authService.handleRedirectObservable().subscribe(data=>{
 
    this.externalAssetService.salesForceInvocationEvent.next({state: decodeURIComponent(window.location.href)});
  })
    this.isIframe = window !== window.parent && !window.opener;
    this.setLoginDisplay();
    this.networkListnerService.listen();
    if (this.authService?.instance?.getAllAccounts()[0]?.idTokenClaims)
      this.blobServiceClientService.handleNetworkReconnection().then(() => {
        this.handleInProgressUpload();
      });
    this.networkListnerService.getNetworkSubscription().subscribe((result: boolean) => {
      if (result) {
        setTimeout(() => {
          this.blobServiceClientService.handleNetworkReconnection().then(() => {
            this.blobServiceClientService.getUploadStatus().next(true);
            this.signalRService.startConnection();
            this.signalRService.connectivityStatusListener();
            this.signalRService.deploymentResponseListener();
            this.patchManagementService.notifyNetworkReconnectSubscription();
          });
        }, 2000)

      }
      else {
        this.blobServiceClientService.handleNetworkOutage();
      }
    });
    this.signalRService.getLoginActivity().subscribe((result: LoginSession) => {
      const userClaim = this.authService.instance.getAllAccounts()[0].idTokenClaims as any;
      if (userClaim && result && result.userId == userClaim['email'] && result.sessionCreatedEPOC) {
        const sessionCreatedEPOC = localStorage.getItem("sessionCreatedEPOC");
        if (result.sessionCreatedEPOC != sessionCreatedEPOC) {
          sessionStorage.setItem("SingleSessionlogoutUser", userClaim['email']);
          this.blobServiceClientService.handleNetworkReconnection().then(() => {
            this.handleInProgressUpload();
          }).finally(() => {
            this.isLoggedOut = true;
            this.showLoggedOutDialog();
          });

        }
      }
    })
    this.msalSubscription = this.msalBroadcastService.msalSubject$.subscribe((event: EventMessage) => {
      if (event.eventType === EventType.LOGIN_SUCCESS) {
        this.handleSessionManagement(this.authService.instance.getAllAccounts()[0].idTokenClaims);
      }
      else if(event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) {
        if (sessionStorage.getItem("SingleSessionlogoutUser")  == (this.authService?.instance?.getAllAccounts()[0]?.idTokenClaims as any)["email"]) {
          if(!this.isLoggedOut)
          this.showLoggedOutDialog();
        }
      }
    });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
      });

    setTimeout(() => {
      if (!this.loginDisplay) {
        this.spinner.show();
        this.loginRedirect();
      }
    }, 2000);
    this.resetTimer();
    // patch download response
    this.signalRService.deploymentResponse.subscribe(data => {
      if (data.requestId) {
        const userClaim = this.authService.instance.getAllAccounts()[0]?.idTokenClaims as any;
        if (userClaim && userClaim['email'] == data.userEmail) {
          if (data.downloadStatus == EventCode.patchDownloadCompleted) {
            const dialogRef = this.dialog.open(SendPackageSuccessDialogComponent, {
              disableClose: true,
              autoFocus: false,
              data: data // change this
            });
          }
          if (data.downloadStatus == EventCode.patchDownloadCancelled || data.downloadStatus == EventCode.patchDownloadFailed ||data.downloadStatus == EventCode.patchDownloadCancelledOld) { // null
            const dialogRef = this.dialog.open(SendPackageErrorDialogComponent, {
              disableClose: true,
              autoFocus: false,
              data: data // change this
            });
          }
        }
      }
    }
    );
    this.signalRService.packageUploadStatus();
  }


  modalPopUp(data: string) {
    this.isTimeout = false;
    if (data === 'Yes') {
      clearTimeout(this.autoLoggoutTime);
      if (this.dataStateKeeperService.getIsUnsavedDataExist()) {
        this.showUnSavedDataDialog();
      }
      else
        this.logout();

    } else if (data === 'No') {
      clearTimeout(this.autoLoggoutTime);
      this.isTimeout = false;
    }
  }
  @HostListener('document:mousemove')
  @HostListener('document:keypress')
  @HostListener('document:click')
  @HostListener('document:wheel')
  resetTimer(keepSessionCount = false) {
    if (this.isInactivityCounterEnabled) {
      clearInterval(this.time);
      if (!keepSessionCount)
        this.extendedSessionCount = 0;
      this.time = setInterval(() => {
        if (this.blobServiceClientService.isUploadInProgress()) {
          if (this.extendedSessionCount > 6) {
            this.initiateInactivityLogout();
          }
          else {
            this.extendedSessionCount++;
            this.resetTimer(true);
          }
        }
        else {
          this.initiateInactivityLogout();
        }
      }, this.userInactivityTimeOut);
    }
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }

  checkAndSetActiveAccount() {
    let activeAccount = this.authService.instance.getActiveAccount();

    if (
      !activeAccount &&
      this.authService.instance.getAllAccounts().length > 0
    ) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
    }
  }
  showUnSavedDataDialog() {
    const confirmDialogRef = this.dialog.open(LogoutUnsavedDataPopupComponent, {
      disableClose: true
    });
    this.dataLostMessageTimer = setInterval(() => {
      confirmDialogRef.close();
      clearInterval(this.dataLostMessageTimer);
    }, this.autoLoggoutTimeOut)

    confirmDialogRef.afterClosed().subscribe((result: boolean) => {
      clearInterval(this.dataLostMessageTimer);
      if (result) {
        this.resetTimer();
      }
      else {
        const dialogRef = this.dialog.open(LoggedOutDialogComponent, { disableClose: true });
        dialogRef.afterClosed().subscribe(() => {
          this.logout();
        })
      }
    });
  }
  initiateInactivityLogout() {
    this.isTimeout = true;
    clearInterval(this.time);
    this.dataStateKeeperService.setIsUnsavedDataExist(false);
    this.dataStateKeeperService.setDataState();
    this.countDown = this.autoLoggoutTimeOut; // two minutes counter
    this.autoLoggoutTime = setInterval(() => {
      this.countDown = this.countDown - 1000;
      if (this.countDown < 1) {
        this.isTimeout = false;
        clearInterval(this.autoLoggoutTime);
        clearInterval(this.time);
        const dialogRef = this.dialog.open(LoggedOutDialogComponent, { disableClose: true });
        this.isInactivityCounterEnabled = false;
        dialogRef.afterClosed().subscribe(() => {
          this.logout();
        })
      }
    }, 1000)
  }
  loginRedirect() {
    if (this.msalGuardConfig.authRequest) {
      this.authService.loginRedirect({
        state: this.routeParams,
        ...this.msalGuardConfig.authRequest,
      } as RedirectRequest);
    } else {
      this.authService.loginRedirect();
    }
  }

  logout() {
    this.clearTimers();
    sessionStorage.removeItem("SingleSessionlogoutUser");
    this.logoutService.userLoggedOut();
    this.authService.logoutRedirect();
  }

  handleSessionManagement(user) {
    const loginSession: LoginSession = {
      statusType: "LoginNotification",
      userId: user.email,
      sessionCreatedEPOC: moment().toISOString()
    }
    localStorage.setItem("sessionCreatedEPOC", loginSession.sessionCreatedEPOC);
    this.singleSessionService.postLoginRequestForSessionTracking(loginSession).subscribe();
  }

  showLoggedOutDialog() {
    this.isInactivityCounterEnabled = false;
    clearInterval(this.time);
    this.loginActivitySubscription?.unsubscribe();
    this.signalRService.stopConnection();
    const dialogRef = this.dialog.open(SessionLoggedOutDialogComponent, {
      disableClose: true,
      data: {
        message: this.translocoService.translate('UserLoggedOut'),
        description: this.translocoService.translate('NewUserLoggedMessage')
      }
    });
    this.clearTimers();
    dialogRef.afterClosed().subscribe(() => {
      this.logout();
    })
  }

  handleInProgressUpload() {
    const userClaim = this.authService.instance.getAllAccounts()[0].idTokenClaims as any;
    this.dashboardService.getSoftwareDashboardData().subscribe(patch => {
      const uploadsInProgress = patch.data.filter(x => ([PatchUploadStatus.UploadInProgress, PatchUploadStatus.UploadInitiated].includes(x.eventCodeShortName))
        && x.uploadedBy == userClaim['email']);
      this.patchManagementService.markUploadsAsFailed(uploadsInProgress).then(() => {
        this.blobServiceClientService.abortUploads();
        this.blobServiceClientService.getUploadStatus().next(true);
      })
    })
  }
  clearTimers() {
    clearInterval(this.time);
    clearInterval(this.autoLoggoutTime);
    clearInterval(this.dataLostMessageTimer);
  }
  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
    this.msalSubscription?.unsubscribe();
    this.loginActivitySubscription?.unsubscribe();
    this.signalRService.stopConnection();
  }
}

